import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Check, BookOpen } from 'lucide-react';
import { Divider } from './botanical/Divider';
import { LemonSlice } from './botanical/LemonSlice';
export function TomosSection() {
  const tomos = [{
    num: '01',
    icon: '🫁',
    title: 'RESPIRACIÓN LIBRE',
    desc: 'Garganta, tos, congestión, fiebre leve y emergencias respiratorias nocturnas. El primer tomo que vas a usar.'
  }, {
    num: '02',
    icon: '🫃',
    title: 'VIENTRE PLANO Y DIGESTIÓN TOTAL',
    desc: 'Panza inflamada, acidez, gases, digestión lenta y pesadez después de comer.'
  }, {
    num: '03',
    icon: '🧠',
    title: 'MENTAL CALM',
    desc: 'Estrés, ansiedad leve, insomnio y agotamiento mental. Recursos simples para bajar el ruido y descansar bien.'
  }, {
    num: '04',
    icon: '💪',
    title: 'EL FIN DEL DOLOR',
    desc: 'Dolores de cabeza, contracturas, tensión muscular y dolores articulares leves.'
  }, {
    num: '05',
    icon: '🛡️',
    title: 'ESCUDO INMUNOLÓGICO',
    desc: 'Cómo preparar el cuerpo para enfermarse menos y recuperarse más rápido. El tomo que más cambia el día a día.'
  }];
  const includes = ['Protocolos paso a paso claros y simples', 'Recetas con ingredientes del súper o dietética', 'Capítulo de emergencia para actuar de noche', 'Checklist de acción inmediata', 'FAQ con las dudas más frecuentes', '100% español rioplatense'];
  return <Section className="bg-cream-warm relative overflow-hidden" data-id="element-414">
      <LemonSlice className="absolute top-1/4 -right-20 w-72 h-72 text-honey opacity-5 blur-md" data-id="element-415" />

      <div className="text-center mb-12 relative z-10" data-id="element-416">
        <div className="inline-flex items-center gap-2 text-moss font-bold tracking-widest uppercase mb-4" data-id="element-417">
          <BookOpen className="w-5 h-5" data-id="element-418" />5 TOMOS COMPLETOS
        </div>
      </div>

      <div className="max-w-4xl mx-auto space-y-6 mb-16 relative z-10" data-id="element-419">
        {tomos.map((tomo, idx) => <Card key={idx} className="flex flex-col sm:flex-row items-start sm:items-center p-6 gap-6 hoverable border-l-4 border-l-moss bg-white/80 backdrop-blur-sm border-sage-mist" data-id="element-420">
            <div className="flex items-center gap-4 sm:w-1/3 shrink-0" data-id="element-421">
              <div className="text-4xl" data-id="element-422">{tomo.icon}</div>
              <div data-id="element-423">
                <div className="text-xs font-bold text-sage-deep uppercase tracking-wider mb-1" data-id="element-424">
                  TOMO {tomo.num}
                </div>
                <h3 className="font-serif font-bold text-forest-deep text-lg leading-tight" data-id="element-425">
                  {tomo.title}
                </h3>
              </div>
            </div>
            <p className="text-forest/80 sm:w-2/3 text-sm md:text-base" data-id="element-426">
              {tomo.desc}
            </p>
          </Card>)}
      </div>

      <Divider className="mb-12" data-id="element-427" />

      <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-sm border border-sage-mist relative z-10" data-id="element-428">
        <h4 className="font-serif font-bold text-xl text-forest-deep text-center mb-6" data-id="element-429">
          Cada tomo incluye:
        </h4>
        <div className="grid sm:grid-cols-2 gap-4" data-id="element-430">
          {includes.map((item, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-431">
              <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-432" />
              <span className="text-forest-deep text-sm font-medium" data-id="element-433">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </Section>;
}